import { render } from "./index.vue?vue&type=template&id=444f2ec2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=444f2ec2&lang=css"
import "./index.vue?vue&type=style&index=1&id=444f2ec2&scoped=true&lang=scss"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444f2ec2"]])

export default __exports__